import {useQuery} from "@apollo/client";
import {useAppContext} from "./useAppContext";
import {ProductRatingsModel} from "../models/view/productRatingsModel";
import {Nullable, RatingType} from "../definitions/types";
import {useMemo, useState} from "react";
import {useRatingPaginationVariables} from "./useRatingPaginationVariables";
import {contentService} from "../api/contentService";

export const useProductRatingsQuery = () => {
    const {productId} = useAppContext();
    const {variables} = useRatingPaginationVariables();
    const [fetchNextPageLoading, setFetchNextPageLoading] = useState<boolean>(false);

    const {data, loading, fetchMore, error} = useQuery(contentService.ratings.query, {
        fetchPolicy: 'cache-and-network',
        variables
    });

    const {
        ratings,
        pageInfo
    } = useMemo(() => data?.userContent?.primaryRatings?.pagination ?? data?.userContent?.ratings?.pagination ?? {
        ratings: [] as Nullable<RatingType>[],
        pageInfo: null
    }, [data]);

    const productRatingsModel = new ProductRatingsModel(productId, ratings, pageInfo);

    return {
        model: productRatingsModel,
        fetchNextPage: () => {
            if (!productRatingsModel.paginationModel.pagination.hasNextPage) return;
            setFetchNextPageLoading(true);
            fetchMore({variables: {pageNumber: productRatingsModel.paginationModel.pagination.nextPageNumber}})
                .catch()
                .finally(() => setFetchNextPageLoading(false));
        },
        fetchNextPageLoading,
        loading,
        error
    };
};